import React from "react";

import { PRODUCT_CONTEXT } from "common-ui-components/components/utils/Config";
import Modal from "common-ui-components/components/modal/Modal";
import styles from "./ReviewPromptModal.module.css";
import CapteraIcon from "./icon/capterraIcon.png";
const G2_REVIEW_URL =
  "https://www.g2.com/products/zecurit/review_modalities/new";
const Capterra_REVIEW_URL =
  "https://reviews.capterra.com/products/new/5a0f9274-82d8-4378-87c0-9ca1c49289d8/";

const REVIEW_CONTENT = {
  em: {
    title: "Help other IT teams discover secure endpoint management.",
    message:
      "You've been successfully managing your endpoints with Zecurit. If we've made your workflow smoother, a quick honest review on Capterra takes less than 2 minutes.",
  },
  ra: {
    title: "How is your remote session experience with Zecurit?",
    message:
      "Fast, encrypted connections keep your workforce productive anywhere. Share your feedback on Zecurit Remote Access to help peers find reliable remote access software.",
  },
  am: {
    title: "Streamlining hardware and software lifecycle with Zecurit?",
    message:
      "From discovery to compliance audits, ITAM keeps your hardware data crystal clear. Let other IT administrators know how Zecurit Asset Manager simplifies your tracking.",
  },
};

const ReviewPromptModal = ({
  isOpen,
  setOpen,
  onClose,
  onRemindLater,
  onDecline,
  onWriteReview,
  onOffersClick,
  reviewUrl = Capterra_REVIEW_URL,
  product = PRODUCT_CONTEXT,
}) => {
  const content = REVIEW_CONTENT[product] || REVIEW_CONTENT.em;
  // const content = REVIEW_CONTENT.am;

  return (
    <Modal
      open={isOpen}
      setOpen={setOpen}
      onClose={onClose}
      className={styles.modal}
      closeIconProps={{ className: styles.closeIcon }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="review-prompt-title"
      >
        <header className={styles.header}>
          <span className={styles.badge}>
            <span aria-hidden="true">★</span> Valued customer
          </span>
          <h2 id="review-prompt-title" className={styles.title}>
            {content.title}
          </h2>
          <span className={styles.heart} aria-hidden="true">
            💚
          </span>
        </header>

        <div className={styles.body}>
          <p className={styles.message}>{content.message}</p>

          <div className={styles.reviewCard}>
            <div className={styles.reviewInfo}>
              {/* <span className={styles.g2Logo} aria-hidden="true"> */}
              <span>
                <img
                  height="50"
                  src={CapteraIcon}
                  alt="Capterra"
                  className={styles.capteraIcon}
                />
              </span>
              <div>
                <p className={styles.reviewTitle}>Capterra Review</p>
                <p className={styles.stars} aria-label="5 out of 5 stars">
                  ★★★★★
                </p>
              </div>
            </div>
            <a
              className={styles.reviewButton}
              href={reviewUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onWriteReview}
            >
              Write Review →
            </a>
          </div>

          <div className={styles.perkBox}>
            <span className={styles.perkIcon} aria-hidden="true">
              🎁
            </span>
            <p className={styles.perkText}>
              Reviews unlock exclusive perk rewards. Check what you can claim on
              the{" "}
              <button
                type="button"
                className={styles.perkLink}
                onClick={onOffersClick}
              >
                Offers page under Settings
              </button>
              .
            </p>
          </div>
        </div>

        <footer className={styles.footer}>
          <button
            type="button"
            className={styles.remindButton}
            onClick={onRemindLater}
          >
            Remind me later
          </button>
          <button
            type="button"
            className={styles.declineButton}
            onClick={onDecline}
          >
            No thanks
          </button>
        </footer>
      </div>
    </Modal>
  );
};

export default ReviewPromptModal;
